import { api } from '../api.js';
import { el, clear, fragment } from '../dom.js';
import { t } from '../i18n.js';
import { openSeriesForm } from './series-form.js';
import { renderCalendar } from './calendar.js';
import { seriesCard } from './series-list.js';
import { institutionScope, institutionHead, NoAccessError, accessDenied } from './institution-scope.js';

// One institution's programme: the month and the series that produce it, on one
// screen. This is the workspace *for that institution*, reached from the list
// on /panel, and its address carries the nickname — so it is linkable, it can
// be opened in two tabs beside each other, and nothing has to remember which
// account you last picked.
export async function renderDates({ params, query }) {
  let scope;
  try {
    scope = await institutionScope(params[0]);
  } catch (error) {
    if (!(error instanceof NoAccessError)) throw error;
    return accessDenied();
  }

  const accountId = scope.account.id;
  let series = await api.get(`/accounts/${accountId}/series`);

  const list = el('ul', { class: 'card-list' });
  const notice = el('p', { class: 'cal-hint', role: 'status' });
  notice.hidden = true;

  async function reload(message) {
    series = await api.get(`/accounts/${accountId}/series`);
    paint();
    // The month above the list, not only the list. Anything that changes what
    // exists — a delete, a publish, a pause, a shift — changes both.
    await calendar?.reload();
    if (message) {
      notice.textContent = message;
      notice.hidden = false;
    }
  }

  function paint() {
    clear(list);
    if (series.length === 0) {
      list.append(el('li', {}, el('div', { class: 'pub-empty' }, t.seriesEmpty)));
      return;
    }
    for (const row of series) list.append(seriesCard(row, accountId, reload));
  }

  paint();

  const newEvent = el('button', { class: 'button', type: 'button' }, t.newEvent);
  newEvent.addEventListener('click', () => openSeriesForm({
    venueId: accountId, accounts: scope.accounts, onSaved: reload,
  }));

  const calendar = await renderCalendar({
    accountId, query, basePath: `/panel/i/${scope.account.slug}`,
  });

  return fragment([
    institutionHead(scope, 'dates'),
    el('p', { class: 'row' }, [newEvent]),
    notice,
    calendar,
    el('h2', { class: 'bucket-title' }, t.series),
    list,
  ]);
}
